<template>
  <Bar
    id="report-chart"
    :options="chartOptions"
    :data="chartData"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

// Register required Chart.js components
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'ReportChart',
  components: { Bar },

  data() {
    return {
      stats: [],
      importPort: [],
      exportPort: [],
      departs: [],
      chartData: {
        // labels: [
        //   'التصدير المؤقت (بوابة الخروج)',
        //   'الإستيراد المؤقت (بوابة الدخول)',
        //   'المجموع'
        // ],
        // datasets: [
        //   {
        //     label: 'الطلبات المقدمة',
        //     data: [7250, 7609, 14859],
        //     backgroundColor: '#11dddd',
        //     borderRadius: 6,
        //     barPercentage: 0.6
        //   },
        //   {
        //     label: 'الطلبات المقبولة (المغادرة)',
        //     data: [7101, 7119, 14220],
        //     backgroundColor: '#441111',
        //     borderRadius: 6,
        //     barPercentage: 0.6
        //   },
        //   {
        //     label: 'الطلبات العائدة',
        //     data: [7151, 7120, 14271],
        //     backgroundColor: '#4f46e5',
        //     borderRadius: 6,
        //     barPercentage: 0.6
        //   }
        // ]
      },

      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            labels: { color: '#374151', font: { size: 14 } }
          },
          title: {
            display: true,
            text: 'Applicants per Month',
            color: '#111827',
            font: { size: 18, weight: 'bold' }
          }
        },
        scales: {
          x: {
            ticks: { color: '#6b7280' },
            grid: { display: true }
          },
          y: {
            beginAtZero: true,
            ticks: { color: '#6b7280' },
            grid: { color: '#e5e7eb' }
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['getDeparts'])
  },
  async created() {
  await  this.fetchOptions()
  await  this.fetchAllStats()
    this.fillChartData()
  },
  methods: {
    /** */
    ...mapActions([
      'fetchDeparts',
    ]),
    /********************************/
    async fetchOptions() {
      if (this.getDeparts.length == 0) {
        await this.fetchDeparts(); // Fetch and store in Vuex
      }
      this.departs = this.getDeparts
    },

    /********************************/
    /** */
    async fetchAllStats() {
      try {
        const summeryResponse = await this.$axios.get("api/employee/report/statssummary")

        if (summeryResponse?.data.isSuccess) {
          const summeryData = summeryResponse.data.data;
          this.stats = summeryData[0]
          // this.importPort = summeryData[0].report
          
        } else {
          this.$tempAlert(summeryResponse?.data.msg, 'warning');
        }
      } catch (error) {
        if (error.summeryResponse?.data) {
          this.$tempAlert(error.summeryResponse?.data.msg, 'warning');
        }
        console.error("Error fetching privileges and groups:", error);
      }
    },
    /******************************/
    /** */
    fillChartData() {
          this.chartData = {
            labels: [
              this.$appType.full[this.stats.report[0].appType],
              this.$appType.full[this.stats.report[1].appType],
              'المجموع'
            ],
            datasets: [
              {
                label: 'الطلبات المقدمة',
                data: [
                  this.stats.report[0].monthly.totalApplicant,
                  this.stats.report[1].monthly.totalApplicant,
                  this.stats.report[0].monthly.totalApplicant + this.stats.report[2].monthly.totalApplicant
                ],
                backgroundColor: '#11dddd',
                borderRadius: 6,
                barPercentage: 0.6
              },
              {
                label: 'الطلبات المقبولة (المغادرة)',
                data: [
                  this.stats.report[0].monthly.departVehicles,
                  this.stats.report[1].monthly.departVehicles,
                  this.stats.report[0].monthly.departVehicles + this.stats.report[2].monthly.departVehicles
                ],
                backgroundColor: '#441111',
                borderRadius: 6,
                barPercentage: 0.6
              },
              {
                label: 'الطلبات العائدة',
                data: [
                  this.stats.report[0].monthly.returnVehicles,
                  this.stats.report[1].monthly.returnVehicles,
                  this.stats.report[0].monthly.returnVehicles + this.stats.report[2].monthly.returnVehicles
                ],
                backgroundColor: '#4f46e5',
                borderRadius: 6,
                barPercentage: 0.6
              }
            ]
          }
        }
          /***************************/
  }
}
</script>

<style scoped>
#report-chart {
  height: 400px;
  width: 100%;
}
</style>
